import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0e7db94"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "game-matrix-display",
    style: _normalizeStyle(_ctx.containerStyle),
    key: _ctx.remounts
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matrix.items, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        style: _normalizeStyle(_ctx.styleByItem(item)),
        class: _normalizeClass([_ctx.classByItem(item), "game-matrix-display__item"]),
        onClick: ($event: any) => (_ctx.handleItemClick(item))
      }, [
        _createElementVNode("p", null, _toDisplayString(_ctx.itemDisplayValue(item)), 1)
      ], 14, _hoisted_1))
    }), 128))
  ], 4))
}